__turbopack_context__.v({
  "closeButton": "BookingModal-module__EmgdDq__closeButton",
  "content": "BookingModal-module__EmgdDq__content",
  "dateButton": "BookingModal-module__EmgdDq__dateButton",
  "dateButtonActive": "BookingModal-module__EmgdDq__dateButtonActive",
  "dateSelector": "BookingModal-module__EmgdDq__dateSelector",
  "dayOfMonth": "BookingModal-module__EmgdDq__dayOfMonth",
  "dayOfWeek": "BookingModal-module__EmgdDq__dayOfWeek",
  "footer": "BookingModal-module__EmgdDq__footer",
  "header": "BookingModal-module__EmgdDq__header",
  "input": "BookingModal-module__EmgdDq__input",
  "loadingText": "BookingModal-module__EmgdDq__loadingText",
  "modal": "BookingModal-module__EmgdDq__modal",
  "noSlotsText": "BookingModal-module__EmgdDq__noSlotsText",
  "overlay": "BookingModal-module__EmgdDq__overlay",
  "select": "BookingModal-module__EmgdDq__select",
  "step": "BookingModal-module__EmgdDq__step",
  "stepTitle": "BookingModal-module__EmgdDq__stepTitle",
  "submitButton": "BookingModal-module__EmgdDq__submitButton",
  "timeSlotButton": "BookingModal-module__EmgdDq__timeSlotButton",
  "timeSlotButtonActive": "BookingModal-module__EmgdDq__timeSlotButtonActive",
  "timeSlots": "BookingModal-module__EmgdDq__timeSlots",
  "userInfo": "BookingModal-module__EmgdDq__userInfo",
});
